<template>
  <div class="login">
    <div class="loginBox">
      <div class="head">
        <!-- <img class="imgSty" src="../assets/logo2.png" alt="" /> -->
      </div>
      <div class="content">
        <div class="content_name">成都中医药大学博物馆预约管理系统</div>
        <div class="inp_box">
          <el-input
            class="input_sty"
            v-model="loginUse.username"
            placeholder="请输入用户名"
            size="small"
          ></el-input>
          <el-input
            class="input_sty"
            placeholder="请输入密码"
            v-model="loginUse.password"
            show-password
            size="small"
          ></el-input>
        </div>
        <div class="but_box">
          <button class="login_but" @click="login">登录系统</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loginUse: {
        username: "",
        password: "",
        // rememberMe: false,
        // tenantName: "芋道源码",
      },
    };
  },
  methods: {
    login() {
      // /admin-api/system/auth/login
      this.$axiosPost("/admin-api/system/auth/login", {
        ...this.loginUse,
      }).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.$message({
            showClose: true,
            message: "登录成功",
            type: "success",
          });
          localStorage.setItem("accessToken", res.data.accessToken);
          this.$router.push("/personalAuditing");
        }
      }).catch((error)=>{
        if(error.msg){
          this.$message.error(error.msg);
        }else{
          this.$message.error('登录未响应');
        }
        
      });
    },
  },
};
</script>

<style scoped>
.login {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.loginBox {
  height: 323px;
  width: 416px;
  border: 1px solid rgba(163, 0, 20, 1);
  border-radius: 5px;
}

.head {
  border-radius: 5px;
  height: 53px;
  background: url(../assets/logo2.png);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 62% 100%;
  display: flex;
  justify-content: center;
  align-content: center;
  border-bottom: 1px solid rgba(163, 0, 20, 1);

}

.imgSty {
  width: 254px;
  height: 41px;
}
.content_name {
  text-align: center;
  margin-top: 25px;
  margin-bottom: 25px;
}
.but_box {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.login_but {
  width: 225px;
  height: 36px;
  border: 1px solid rgba(121, 121, 121, 1);
  background-color: rgba(174, 79, 93, 1);
  border-radius: 4px;
  color: #eeeeee;
}
.input_sty {
  width: 225px;
  height: 32px;
  margin: 5px;
}
.inp_box {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
</style>
